import './FloatingSocial.css';
import { useContext } from 'react';
import { ConfigContext } from '../../assets/contexts/configContext';
import { DEFAULT_SOCIAL_VALUES_MAP } from '../../assets/utils/socials/socials_constants';


function FloatingSocial() {
    const config = useContext(ConfigContext)
    const { initialConstants } = config
    const { CONSTANTS } = initialConstants
    const { SHOW_SOCIALS_ICON_IN_FOOTER = true, SHOW_SOCIALS_NAME_IN_FOOTER = false } = CONSTANTS
    const { SOCIAL_NETWORKS } = initialConstants

    return (
        <div className="floating-social">
            {/* <div className='FloatingSocial__box'> */}
            {/* <div className='FloatingSocial__content-box'> */}
            {SOCIAL_NETWORKS && Array.isArray(SOCIAL_NETWORKS) && SOCIAL_NETWORKS.length > 0 ?
                <div className='footer__socials'>
                    {SOCIAL_NETWORKS.map((social, i) => {
                        const SOCIAL = DEFAULT_SOCIAL_VALUES_MAP[social.type]
                        return (
                            <a className={`footer__social footer__social-${social.type} `} href={social.url} target='_blank' rel='noreferrer' key={`footer__social${social._id}${i}`}>
                                {SHOW_SOCIALS_ICON_IN_FOOTER ?
                                    SOCIAL.icon({ mainClassName: `footer__social-icon footer__social-icon-${social.type}`, fillClassName: `footer__social-icon-fill footer__social-icon-${social.type}`, bgFillClassName: `footer__social-icon-bg-fill footer__social-icon-bg-fill-${social.type}` }) : null}
                                {SHOW_SOCIALS_NAME_IN_FOOTER ? <p className='footer__social-title'>{SOCIAL.title}</p> : null}
                            </a>
                        )
                    })}
                </div>
                :
                null
            }
            {/* </div> */}
            {/* </div> */}
            {/* <p>phjhjhjh</p> */}
        </div>
    );
}

export default FloatingSocial